﻿import * as $resources from './_resources'

var callno:number = 0;

export function show(message:string = $resources.text.loading) {
    $("#bcfla-loading-text").html(message);
    $("#bcfla-loading").addClass("bcfla-loading-visible");
    callno++;
}

export function hide() {
    callno--;

    if (callno <= 0) {
        $("#bcfla-loading-text").html("");
        $("#bcfla-loading").removeClass("bcfla-loading-visible");
        callno = 0;
    }
}